import { DoubleSide } from 'three'
import { MaterialPeca, Peca } from '../componentes/Peca'
import { useDeslocamentoRigido } from './contextoDeformacao'

/**
 * Caixa de roda: meia volta de arco, como o entalhe da silhueta externa.
 *
 * O giro de 90° em Y põe o anel no plano ZY, que é o plano da lateral.
 */
export function CaixaDeRoda3D({
  id,
  x,
  y,
  z,
  raio,
  afastamento,
  modoAlvo = false,
}: {
  id: string
  x: number
  y: number
  z: number
  raio: number
  afastamento: [number, number, number]
  modoAlvo?: boolean
}) {
  const [dx, dy, dz] = useDeslocamentoRigido([x, y, z])
  const malhas = <>
      <mesh position={[x + dx, y + dy, z + dz]} rotation={[0, Math.PI / 2, 0]}>
        <torusGeometry args={[raio, 0.025, 8, 20, Math.PI]} />
        {modoAlvo ? <meshStandardMaterial color="#455264" roughness={0.8} /> : <MaterialPeca id={id} />}
      </mesh>
      <mesh name="caixa-roda-interna" position={[x + dx, y + dy, z + dz]} rotation={[0, 0, Math.PI / 2]}>
        <cylinderGeometry args={[raio, raio, 0.18, 24, 1, true, 0, Math.PI]} />
        {modoAlvo ? <meshStandardMaterial color="#25303d" roughness={0.9} side={DoubleSide} /> : <MaterialPeca id={id} ladoDuplo />}
      </mesh>
  </>
  return modoAlvo ? <group>{malhas}</group> : <Peca id={id} deslocamentoAfastado={afastamento}>{malhas}</Peca>
}

